import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87df3f64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-sign__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_uf_signature = _resolveComponent("uf-signature")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_image, {
            width: "100%",
            height: "100%",
            fit: "contain",
            src: _ctx.src,
            onClick: _ctx.onClick
          }, null, 8, ["src", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["title", "required", "readonly"]),
    _createVNode(_component_uf_signature, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popupShow) = $event)),
      onConfirm: _ctx.onConfirm
    }, null, 8, ["show", "onConfirm"])
  ], 64))
}